import { render, staticRenderFns } from "./TaskFieldLabels.vue?vue&type=template&id=7b85d0fc&"
import script from "./TaskFieldLabels.vue?vue&type=script&lang=js&"
export * from "./TaskFieldLabels.vue?vue&type=script&lang=js&"
import style0 from "./TaskFieldLabels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports